<template>
  <div :class="componentClassName">
    <div class="m-specific-number-setting__fields">
      <a-switch
        v-model="specificNumberFlag"
        label="特定番号対応の設定"
        :disabled="viewOnly"
        @change="updateModelData"
      />
      <template v-if="specificNumberFlag">
        <m-form-input align="left" label="特定番号の指定">
          <a-button
            id="openUploadModalButton"
            class="m-specific-number-setting__upload-button"
            variant="block"
            color="primary"
            size="small"
            label="アップロード"
            icon="upload"
            :disabled="viewOnly"
            @click="uploadModalVisible = true"
          />
        </m-form-input>
        <m-form-input align="left" label="登録された特定番号のCSVダウンロード">
          <a-button
            id="specificNumberDownload"
            class="m-specific-number-setting__download-button"
            variant="block"
            color="primary"
            label="ダウンロード"
            icon="download"
            size="small"
            :disabled="!specificNumberList || !specificNumberList.length || viewOnly"
            @click="handleDownloadNumberList()"
          />
        </m-form-input>
        <m-form-input label="特定番号の対応方法">
          <a-select-field
            id="specificNumberSettingResponseModeOptions"
            v-model="specificNumberCondition"
            :options="responseModeOptions"
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <m-form-input v-if="specificNumberCondition === 'voicemailGuidance'" label="ガイダンス内容">
          <a-text-field
            id="specificNumberSettingVoicemailGuidance"
            v-model="specificNumberVoicemailGuidance"
            type="textarea"
            rows="7"
            placeholder=""
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <m-form-input v-if="specificNumberCondition === 'disconnectGuidance'" label="ガイダンス内容">
          <a-text-field
            id="specificNumberSettingDisconnectGuidance"
            v-model="specificNumberDisconnectGuidance"
            type="textarea"
            rows="7"
            placeholder=""
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <div
          v-if="specificNumberCondition === 'voicemailGuidance' || specificNumberCondition === 'disconnectGuidance'"
          class="m-specific-number-setting__button"
        >
          <a-button
            v-show="!isVoicePlaying"
            id="play"
            variant="fill"
            color="primary"
            size="small"
            icon="play"
            icon-color="white"
            @click="handleTestButtonClick"
          >
            テスト再生
          </a-button>
          <a-button
            v-show="isVoicePlaying"
            id="stop"
            variant="fill"
            color="primary"
            size="small"
            icon="audio-pause"
            icon-color="white"
            :disabled="!specificNumberFlag"
            @click="handleTestButtonClick('stop')"
          >
            テスト停止
          </a-button>
        </div>
        <m-form-input v-if="specificNumberCondition === 'disconnectGuidance'" label="">
          <a-switch
            id="specificNumberSettingNotificationFlag"
            v-model="specificNumberNotificationFlag"
            label="メール通知"
            :disabled="viewOnly"
            @change="updateModelData"
          />
          <span class="a-switch__label"></span>
          <a-text-field
            id="specificNumberSettingNotificationEmail"
            v-model="specificNumberNotificationEmail"
            maxlength="50"
            :disabled="!specificNumberNotificationFlag || viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <m-form-input v-if="specificNumberCondition === 'transfer'" label="電話番号">
          <a-text-field
            id="specificNumberSettingPhoneNumber"
            v-model="specificNumberTransferNumber"
            maxlength="11"
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <m-form-input v-if="specificNumberCondition === 'voiceDXTransfer'" label="COTOHA Voice DX Basic番号名称">
          <a-select-field
            id="specificNumberSettingVoiceDXTransfer"
            v-model="specificNumberVoiceDXTransferNumber"
            :options="vdxPhoneNumberList"
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <m-form-input v-if="specificNumberCondition === 'user'" label="着信グループ名">
          <a-select-field
            id="specificNumberSettingGroupName"
            v-model="specificNumberGroupName"
            :options="userGroupOptions"
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
      </template>
    </div>
    <teleport to="body">
      <o-modal
        id="specificNumberInfoModal"
        v-model:visible="infoModalVisible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="9999"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ infoModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="infoModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="modal-ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
      <o-modal
        id="specificNumberUploadModal"
        v-model:visible="uploadModalVisible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="9998"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :show-header="false"
      >
        <a-text :center="true" color="red" weight="bold">
          登録済みの番号リストがある場合は 上書きされますのでご注意ください
        </a-text>
        <a-text>&nbsp;</a-text>
        <a-text :center="true">
          テンプレートのダウンロードは
          <a-button
            id="downloadTemplateButton"
            class="m-specific-number-setting__download-template-button"
            variant="text"
            color="primary"
            label="こちら"
            size="medium"
            @click="handleDownloadCsvTemplate()"
          />
        </a-text>
        <a-text>&nbsp;</a-text>
        <m-form-input label="アップロード">
          <a-upload-field
            id="specificNumberSettingUpload"
            v-model="uploadFile"
            accept=".csv,.CSV"
            :disabled="isUploading"
            @change="handleFileUploadChange(uploadFile)"
          />
        </m-form-input>
        <template #footer>
          <a-button
            id="specificNumberUploadOKButton"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleUploadFile()"
          />
          <a-button
            id="specificNumberUploadCancelButton"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            @click="handleCancelUploadFile()"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import languageEncoding from 'detect-file-encoding-and-language';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';

export default {
  name: 'm-specific-number-setting',
  components: {},
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    setting: {
      type: Object,
      default: null,
    },
    originalSetting: {
      type: Object,
      default: null,
    },
    responseModeOptions: {
      type: Array,
      default: new Array(0),
    },
    userGroupOptions: {
      type: Array,
      default: new Array(0),
    },
    vdxPhoneNumberList: {
      type: Array,
      default: new Array(0),
    },
    companyName: {
      type: String,
      default: '',
    },
    isVoicePlaying: {
      type: Boolean,
      default: false,
    },
    voiceList: {
      type: Array,
      default: new Array(0),
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:specificNumberSetting', 'play', 'stop'],
  data() {
    return {
      specificNumberFlag: false,
      uploadFile: null,
      specificNumberList: [],
      specificNumberCondition: '',
      specificNumberVoicemailGuidance: '',
      specificNumberDisconnectGuidance: '',
      specificNumberNotificationFlag: false,
      specificNumberNotificationEmail: '',
      specificNumberTransferNumber: '',
      specificNumberVoiceDXTransferNumber: '',
      specificNumberGroupName: '',
      currentVoice: '',

      // modal
      infoModalVisible: false,
      infoModalTitle: '',
      infoModalContent: '',
      uploadModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-specific-number-setting', this.responseMode);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    specificNumberCondition(val) {
      if (val === 'user') {
        if (this.userGroupOptions && this.userGroupOptions.length && !this.specificNumberGroupName) {
          this.specificNumberGroupName = this.userGroupOptions[0].value;
        } else {
          this.specificNumberGroupName = this.setting.specificNumberGroupName || '';
        }
        this.updateModelData();
      }
    },
  },
  created() {
    this.specificNumberFlag = this.setting.specificNumberFlag;
    this.specificNumberCondition = this.setting.specificNumberCondition;
    this.specificNumberVoicemailGuidance = this.setting.specificNumberVoicemailGuidance;
    this.specificNumberDisconnectGuidance = this.setting.specificNumberDisconnectGuidance;
    this.specificNumberNotificationEmail = this.setting.specificNumberNotificationEmail;
    this.specificNumberNotificationFlag = this.setting.specificNumberNotificationFlag;
    this.specificNumberTransferNumber = this.setting.specificNumberTransferNumber;
    this.specificNumberVoiceDXTransferNumber = this.setting.specificNumberVoiceDXTransferNumber;
    this.specificNumberGroupName = this.setting.specificNumberGroupName;
    this.specificNumberList = this.setting.specificNumberList || [];

    if (!this.setting.specificNumberFlag) this.specificNumberCondition = 'disconnect';
    if (!this.setting.specificNumberVoicemailGuidance)
      this.specificNumberVoicemailGuidance = messageContent.defaultVoicemailGuidance(this.companyName);
    if (!this.setting.specificNumberDisconnectGuidance)
      this.specificNumberDisconnectGuidance = messageContent.defaultDisconnectGuidance(this.companyName);
  },
  mounted() {
    if (this.voiceList.length > 0 && this.currentVoice === '') {
      this.currentVoice = this.voiceList[0].value || '';
    }
  },
  methods: {
    async handleFileUploadChange(file) {
      const reader = new FileReader();

      if (file[0]) {
        const targetFile = new File([file[0]], file[0].name, { type: file[0].type });
        const fileInfo = await languageEncoding(targetFile);
        if (targetFile.type.toLowerCase() !== 'text/csv') {
          this.clearInputCsvFile();
          this.showErrorModal(messageContent.csvSelectRequired);
          return;
        }
        if (!fileInfo.encoding || fileInfo.encoding.toLowerCase() !== 'utf-8') {
          this.clearInputCsvFile();
          this.showErrorModal(messageContent.csvFileEncodingNotUTF8);
          return;
        }
        reader.readAsText(targetFile);
      } else {
        this.clearInputCsvFile();
      }
      const self = this;
      reader.onload = () => {
        self.specificNumberList = [];
        const csvDataArr = reader.result.split(/\r?\n/);
        const tempList = [];
        let i = 1;
        for (let number of csvDataArr) {
          if (i === 1) {
            i++;
            continue; // ヘッダをスキップ
          }
          number = number.trim();
          if (!number) {
            i++;
            continue; // 行は空の場合はスキップとする
          }
          if (number[0] !== '0' || !self.isPhoneNumber(number)) {
            self.showErrorModal(messageContent.lineXXInvalidSpecificNumber(i));
            self.clearInputCsvFile();
            return;
          }
          tempList.push(number);
          i++;
        }
        if (!tempList.length) {
          self.showErrorModal(messageContent.requireMinRegister('特定番号', 1));
          self.clearInputCsvFile();
          return;
        }
        if (tempList.length > 1000) {
          self.showErrorModal(messageContent.requireMaxRegister('特定番号', 1000));
          self.clearInputCsvFile();
          return;
        }
        self.specificNumberList = tempList;
        self.updateModelData();
      };
      reader.onerror = () => {
        self.clearInputCsvFile();
        self.showErrorModal(messageContent.numbermgmtCsvUploadError);
      };
    },
    handleUploadFile() {
      if (!this.specificNumberList.length) {
        this.showErrorModal(messageContent.csvSelectRequired);
        this.clearInputCsvFile();
        return;
      }
      this.uploadModalVisible = false;
    },
    handleCancelUploadFile() {
      this.uploadModalVisible = false;
      this.clearInputCsvFile();
    },
    clearInputCsvFile() {
      this.uploadFile = null;
      this.specificNumberList =
        this.originalSetting && this.originalSetting.specificNumberSetting
          ? this.originalSetting.specificNumberSetting.specificNumberList || []
          : [];
    },
    handleDownloadCsvTemplate() {
      const csv = '特定番号\r\n';
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csv], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);

      const file_name = 'specific_number_list_template';
      anchor.download = file_name + '.csv';
      anchor.href = url;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    },
    handleDownloadNumberList() {
      const csv = ['特定番号', ...this.specificNumberList].join('\r\n');
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csv], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);

      const file_name = 'specific_number_list';
      anchor.download = file_name + '.csv';
      anchor.href = url;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    },
    updateModelData() {
      const data = {
        specificNumberList: this.specificNumberList,
        specificNumberFlag: this.specificNumberFlag,
        specificNumberCondition: this.specificNumberCondition,
        specificNumberVoicemailGuidance: this.specificNumberVoicemailGuidance,
        specificNumberDisconnectGuidance: this.specificNumberDisconnectGuidance,
        specificNumberNotificationFlag: this.specificNumberNotificationFlag,
        specificNumberNotificationEmail: this.specificNumberNotificationEmail,
        specificNumberTransferNumber: this.specificNumberTransferNumber,
        specificNumberVoiceDXTransferNumber: this.specificNumberVoiceDXTransferNumber,
        specificNumberGroupName: this.specificNumberGroupName,
      };
      this.$emit('update:specificNumberSetting', data);
    },
    handleTestButtonClick(e) {
      if (e === 'stop') {
        return this.$emit('stop');
      }
      this.$emit('play', {
        voice: this.currentVoice,
        content:
          this.specificNumberCondition === 'disconnectGuidance'
            ? this.specificNumberDisconnectGuidance
            : this.specificNumberCondition === 'voicemailGuidance'
            ? this.specificNumberVoicemailGuidance
            : '',
      });
      return '';
    },
    showInfoModal(content) {
      this.infoModalTitle = messageContent.infoModalTitle;
      this.infoModalVisible = true;
      this.infoModalContent = content;
    },
    showErrorModal(message) {
      this.infoModalVisible = true;
      this.infoModalTitle = messageContent.errorModalTitle;
      this.infoModalContent = message;
    },
    handleCloseModal() {
      this.infoModalVisible = false;
      this.infoModalTitle = '';
      this.infoModalContent = '';
    },
  },
};
</script>
